import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { MdOutlinedFlag } from "react-icons/md";
import { HiOutlineTicket } from "react-icons/hi";
import { OpenInNewRounded } from "@mui/icons-material";
import { Box, ListItemIcon, ListItemText, MenuItem } from "@mui/material";

export const RenoAcesLink = () => (
  <Link
    target="_blank"
    sx={{
      fontWeight: 500,
      color: "primary.main",
      textDecoration: "none",
    }}
    href="https://mlb.tickets.com/?agency=RENM_MYTIXX&orgid=53073#/auth/login?fullret=%2Fticketmanagement%2F%3Fagency%3DRENM_MYTIXX&orgid=53073"
  >
    MyTickets
  </Link>
);

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose your games.",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Suite",
    description: "Select the suite you wish to purchase for your game.",
  },

  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your Reno Aces <RenoAcesLink /> account.
        Reach out to Live Fan Support for any questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "When will I receive my ticket?",
    description: (
      <>
        Tickets will be delivered to you digitally via your Reno Aces{" "}
        <Link
          target="_blank"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
          href="https://mlb.tickets.com/?agency=RENM_MYTIXX&orgid=53073#/auth/login?fullret=%2Fticketmanagement%2F%3Fagency%3DRENM_MYTIXX&orgid=53073"
        >
          MyTickets Account
        </Link>{" "}
        at the conclusion of your purchase.
      </>
    ),
  },
  {
    title: "What happens after I purchase a Reno Aces Suite online?",
    description: (
      <>
        Following your purchase, a Reno Aces representative will follow up with
        you to confirm your order and assist with any questions you have in
        anticipation of your event. Tickets and parking will be added to your
        Reno Aces account where you&apos;ll be able to access them via the Reno
        Aces <RenoAcesLink /> account. All suite tickets are digital
      </>
    ),
  },
  {
    title: "What is included in my suite?",
    description:
      "A Reno Aces representative will be in contact with further information, including details regarding parking and food and beverage options.",
  },
];

export const RenoAcesCheckoutTerms = () => (
  <>
    In connection with your purchase, you will receive ticket-related commercial
    emails from renoaces.com. You may unsubscribe at any time. By checking this
    box you agree to receive additional commercial emails from renoaces.com and
    MLB.com. Upon completing your purchase by selecting Purchase Tickets you
    acknowledge and agree that your credit card will be charged. By clicking
    “Purchase Tickets”, you agree to the{" "}
    <Link
      href={
        "https://www.mlb.com/app/ballpark/official-information/privacy-policy"
      }
      target="_blank"
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
    >
      MLB Privacy Policy
    </Link>
    ,{" "}
    <Link
      href={
        "https://www.mlb.com/app/ballpark/official-information/terms-of-use"
      }
      target="_blank"
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
    >
      Terms of Use
    </Link>{" "}
    and to receive your ticket(s) via an SMS text message to the mobile #
    associated with your Reno Aces account. Messaging and data rates may apply.
    Tickets will be made available in the MLB Ballpark mobile application only.
    MLB.com and supported mobile device required.
  </>
);

export const RenoAcesAdditionalDetailsDisclaimerTC = () => (
  <>
    By entering my name, checking the box above and clicking Submit Request, I
    hereby (i) agree to the{" "}
    <Link
      target="_blank"
      href="https://www.mlb.com/app/ballpark/official-information/terms-of-use"
    >
      Terms of Use
    </Link>{" "}
    (ii) agree that my reservation will not be complete unless and until I
    receive a notice from the Reno Aces confirming whether or not my reservation
    has been accepted in accordance with our agreement.
  </>
);

export const RenoAcesTCListItems = () => (
  <Box>
    <MenuItem
      onClick={() => {
        window.open(
          "https://www.mlb.com/app/ballpark/official-information/privacy-policy",
          "_blank"
        );
      }}
    >
      <ListItemIcon>
        <OpenInNewRounded fontSize="small" />
      </ListItemIcon>
      <ListItemText>MLB Privacy Policy</ListItemText>
    </MenuItem>

    <MenuItem
      onClick={() => {
        window.open(
          "https://www.mlb.com/app/ballpark/official-information/terms-of-use",
          "_blank"
        );
      }}
    >
      <ListItemIcon>
        <OpenInNewRounded fontSize="small" />
      </ListItemIcon>
      <ListItemText>MLB Terms of Use</ListItemText>
    </MenuItem>
  </Box>
);

export const RenoAcesRegistrationTerms = () => (
  <>
    By creating an account you agree to be notified regarding your purchase and
    to the{" "}
    <Link
      target={"_blank"}
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href="https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/616882d2b691e09f75348396_Terms%20%26%20Conditions.pdf"
    >
      Terms & Conditions
    </Link>{" "}
    and{" "}
    <Link
      target={"_blank"}
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href="https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/63c05d80816dac05b5b34ac7_seasonshare%20CCPA%20Privacy%20Policy%20Agreement.pdf"
    >
      Privacy Policy
    </Link>
    .
  </>
);
